
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Phone',
  props: {
    color: {
      type: String,
      required: false,
      default: '',
    },
  },
});
